function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M469.34 170.65c-164.95 0-298.67 133.72-298.67 298.67s133.72 298.67 298.67 298.67c80.46 0 153.5-31.82 207.21-83.56 1.12-1.46 2.35-2.87 3.69-4.2s2.75-2.57 4.2-3.69C736.18 622.83 768 549.8 768 469.33c0-164.95-133.72-298.67-298.67-298.67Zm300.03 538.36c52.55-65.7 83.97-149.02 83.97-239.69 0-212.08-171.92-384-384-384s-384 171.92-384 383.99 171.92 384 384 384c90.67 0 173.99-31.42 239.69-83.97l156.81 156.81c16.66 16.66 43.68 16.66 60.34 0 16.66-16.66 16.66-43.68 0-60.34L769.37 709Z",
    style: {
      fillRule: "evenodd"
    }
  }));
};
export default SvgSearch;